import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Frame,
  FrameHeader,
  FrameFooter,
  DisplayMedium,
} from "@conserveit/blocks";
import DynamicFormComponents from "./DynamicFormComponents";
import ReportSelect from "./ReportSelect";
import { Content, ReportWrapper } from "./ReportGeneratorForm.styles";

export default class ReportGeneratorForm extends Component {
  static propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
    onFormSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      reportType: null,
      reportComponents: [],
    };

    this.activeComponentRefs = {};
  }

  dynamicallyRenderForm = (reportType) => {
    if (!reportType) return;

    this.activeComponentRefs = {};
    const reportComponents = [];

    reportType.components.forEach((compName) => {
      const component = DynamicFormComponents[compName];
      if (component) {
        const props = {
          key: compName,
          ref: (element) => {
            this.activeComponentRefs[compName] =
              element && typeof element.getWrappedInstance === "function" // Check if this component is wrapped by a redux connect, if so, extract the underlying component ref
                ? element.getWrappedInstance()
                : element;
          },
        };
        reportComponents.push(React.createElement(component, props));
      }
    });

    this.setState({ reportType, reportComponents });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    let validationSuccess = true;
    let reportOptions = { funcName: this.state.reportType.funcName };

    Object.keys(this.activeComponentRefs).forEach((compName) => {
      const component = this.activeComponentRefs[compName];
      if (component) {
        if (!component.validate()) {
          validationSuccess = false;
        } else {
          reportOptions = {
            ...reportOptions,
            ...component.getSelectedValues(),
          };
        }
      }
    });

    if (!validationSuccess) return;

    this.props.onFormSubmit(this.state.reportType.value, reportOptions);
  };

  render() {
    return (
      <Frame>
        <FrameHeader>
          <DisplayMedium>Report Generator</DisplayMedium>
        </FrameHeader>
        <Content>
          <ReportWrapper>
            <ReportSelect
              disabled={this.props.isFormDisabled}
              selected={this.state.reportType}
              onChange={this.dynamicallyRenderForm}
            />
            {this.state.reportComponents}
          </ReportWrapper>
          {this.props.children}
        </Content>
        <FrameFooter>
          <Button
            onClick={this.handleSubmit}
            disabled={this.props.isFormDisabled || !this.state.reportType}
            type="submit"
            primary
            thin
          >
            {this.props.isFormDisabled ? "Generating..." : "Generate"}
          </Button>
        </FrameFooter>
      </Frame>
    );
  }
}
